const overlay = document.querySelector('.overlay');
const jumpElements = document.querySelectorAll('.gs_jump');

jumpElements.forEach(element => {
    element.addEventListener('click', () => {
        const targetElement = document.querySelector('.slider-mobile-gutter');

        if (targetElement) {
            overlay.style.display = 'block';
            targetElement.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                overlay.style.display = 'none';
            }, 1000);
        }
    });
});